/** Save a file the API sent (e.g. a list's CSV export) through a temporary link. */
export function downloadFile(
  { blob, filename }: { blob: Blob; filename?: string },
  fallbackName: string,
): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename ?? fallbackName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/** A list's filters as a query string for its export — no page, no empties. */
export function exportQuery(values: Record<string, string | undefined>): string {
  const q = new URLSearchParams();
  for (const [key, value] of Object.entries(values)) {
    if (value && key !== 'page' && key !== 'limit') q.set(key, value);
  }
  const s = q.toString();
  return s ? `?${s}` : '';
}
